var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C8.3065 0 0 8.3065 0 18.5C0 28.6935 8.3065 37 18.5 37C28.6935 37 37 28.6935 37 18.5C37 8.3065 28.6935 0 18.5 0ZM25.9 19.8875H19.8875V25.9C19.8875 26.6585 19.2585 27.2875 18.5 27.2875C17.7415 27.2875 17.1125 26.6585 17.1125 25.9V19.8875H11.1C10.3415 19.8875 9.7125 19.2585 9.7125 18.5C9.7125 17.7415 10.3415 17.1125 11.1 17.1125H17.1125V11.1C17.1125 10.3415 17.7415 9.7125 18.5 9.7125C19.2585 9.7125 19.8875 10.3415 19.8875 11.1V17.1125H25.9C26.6585 17.1125 27.2875 17.7415 27.2875 18.5C27.2875 19.2585 26.6585 19.8875 25.9 19.8875Z",
    fill: "#132F44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.281a7fe43c1a6e851d7267e851ecd9d6.svg";
export { ForwardRef as ReactComponent };